import CommodityBidAdminSection from '@/components/admin/CommodityBidAdminSection';

/**
 * Admin CommodityBid tab — live data from CommodityBid API (per registered customer email).
 * Replaces legacy local Mongo `commodity_requests` list which is often empty.
 */
export default function AdminCommodity() {
  return (
    <div className="space-y-5" data-testid="admin-commodity-page">
      <div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">CommodityBid</h1>
        <p className="text-slate-500 text-sm mt-0.5">
          Live production requests, supplier bids, and offers from CommodityBid (synced by customer login email)
        </p>
      </div>
      <CommodityBidAdminSection hideHeader />
    </div>
  );
}
